/**
 * Created by taranveer on 2017-10-02.
 */
if (typeof loadmap === 'undefined') {
    var loadmap = function() {};
}

if (typeof loadpano === 'undefined') {
    var loadpano = function() {};
}

$(document).ready(function(){
    $('.tab_detail_buttons a').click(function(){
        var t = $(this).data('tar');
        console.log(t);

        if (t != 'home_pics') {
            $('.detail_tab').each(function(){
                if ( $(this).attr('id') != t ) {
                    $(this).hide(300);
                } else {
                    $(this).show(300);
                }
            });
        }
    });

    $('#showlising_inquire_first_button').on('click', function(evt) {
        $('.contact_form_expand').trigger('click');
    });


    var options = {
        maintainAspectRatio: false,
        legend: {
            display: false,
            position: 'right'
        },
        scales: {
            yAxes: [{
                display: false
            }],
            xAxes: [{
                ticks: {
                    fontColor: '#fff',
                    min: 0,
                    max: $('#chart').data('max'),
                    stepSize: 100,
                    callback: function(value, index, values) {
                        return '$' + value;
                    }
                },
                gridLines: {
                    display: true,
                    color: '#D8D8D8',
                    zeroLineColor: '#D8D8D8'
                }
            }]
        },
        tooltips: {
            callbacks: {
                title: function(tooltipItem, chartData) {
                    return(chartData.datasets[tooltipItem[0].datasetIndex].label);
                },
                label: function(tooltipItem, chartData) {
                    console.log(chartData.datasets);
                    return '$' + Number(tooltipItem.xLabel);
                }
            }
        }
    };

    initMaps();
    var oneChart = ChartCreator();
    oneChart = oneChart.init('chart', 'Insider Price Scoop', 'horizontalBar', options);
    $('#chartjsLegend').html(oneChart.generateLegend());
    // oneChart.createLegend('chartjsLegend');
});


function initMaps() {
    var minimaps = [];
    $('.listing_minimap').each(function(){
        var map_homeid = $(this).data('homeid');
        var map_div = 'listing_minimap_'+map_homeid;
        var map_lat = Number( $(this).data('lat') );
        var map_lng = Number( $(this).data('lng') );
        if(map_lat !== 0 && map_lng !== 0) {
            // only run IF there's lat/lng specified.. otherwise leave default HTML there.
            // The default HTML shoudl be specified in the listing_display() PHP function, will load faster than dynamic JS based HTml replacemet.
            var map_latlng = brixwork_get_latlng(map_lat, map_lng);
            var map_zoom = (Number( $(this).data('zoom') ) !== 0 ? $(this).data('zoom')*1 : 14); // default to 14
            minimaps[map_homeid] = brixwork_initiate_map(map_div,map_zoom,map_latlng);
            brixwork_create_marker(minimaps[map_homeid], map_latlng);
            brixwork_create_panorama(map_latlng, 'pano_map', 'sFailed to load panorama');

        }
    });
}

function ChartCreator() {
    let $chart,
        data = {
            labels: [],
            datasets: []
        },
        options = {},
        chart = {};

    let init = (chartID, chartName, chartType, chartOptions) => {
        $chart = $(`#${chartID}`);
        data.labels.push(chartName);
        options = chartOptions;

        $chart.children('input').each(function(){
            if ( $(this).data('number') != 0 ) {
                data.datasets.push({
                    label: $(this).data('label'),
                    data: [$(this).data('number')],
                    backgroundColor: $(this).data('background')
                });
            }
        });

        return chart =  new Chart($chart, {
            type: chartType,
            data: data,
            options: options
        });

    };

    let publicAPI = {
        init
    };

    return publicAPI;
}

